// extracted by mini-css-extract-plugin
export default {"avatar":"avatar-module--avatar--1iguJ","icon":"avatar-module--icon--1DynS"};